import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7b980e7e&"
import script from "./App.vue?vue&type=script&ref=AppRoot&lang=js&"
export * from "./App.vue?vue&type=script&ref=AppRoot&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports